import { periodSummary, hasTeamless } from "@/lib/periods";
import { teamStyle } from "@/lib/colors";

const Cell = ({ s, testId }) => (
  <td data-testid={testId} className="py-3 pr-4 align-top">
    <p className={s.counts.length ? "text-zinc-100" : "text-zinc-600"}>{s.text}</p>
    <div className="hidden sm:flex flex-wrap gap-1 mt-1.5">
      {s.counts.map(({ t, n }) => (
        <span key={t.key} className="px-1.5 py-0.5 font-display font-bold text-xs whitespace-nowrap" style={{ background: t.color, color: t.text }}>
          {n} {t.short}
        </span>
      ))}
    </div>
  </td>
);

export const PeriodSummary = ({ match }) => {
  const sides = hasTeamless(match) ? ["home", "away", "none"] : ["home", "away"];
  const head = { home: match.home.name, away: match.away.name, none: "Sem equipa" };
  return (
    <div className="overflow-x-auto -mx-3 px-3 sm:mx-0 sm:px-0">
      <table data-testid="period-summary" className="w-full min-w-[560px] text-sm border-y border-white/10">
        <thead>
          <tr className="border-b border-white/15 text-left">
            <th className="py-3 pr-4 label-caps w-28">Período</th>
            {sides.map((s) => (
              <th key={s} className="py-3 pr-4">
                <span className="inline-block px-2 py-1 font-display text-base font-bold uppercase"
                  style={s === "none" ? { color: "#a1a1aa" } : teamStyle(match[s])}>{head[s]}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-white/10">
          {periodSummary(match).map((b, i) => (
            <tr key={b.label} data-testid={`period-row-${i}`}>
              <td className="py-3 pr-4 align-top font-display text-lg font-bold uppercase whitespace-nowrap">{b.label}</td>
              {sides.map((s) => <Cell key={s} s={b[s]} testId={`period-${s}-${i}`} />)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
